import React from "react";
import PrintCreditHistoryCreditorContactInfoSingle from "./PrintCreditHistoryCreditorContactInfoSingle";
import { ICreditorInfo } from "../../../../store/credit/types";
interface IProps {
    data?: ICreditorInfo[];
}
const PrintCreditHistoryCreditorContactInfo: React.FunctionComponent<IProps> = (props) => {
    let transUnionList = null;
    let equifaxList = null;
    let experianList = null;
    if (props.data != null) {
        transUnionList = props.data.filter((it) => it.bureau === "TransUnion");
        equifaxList = props.data.filter((it) => it.bureau === "Equifax");
        experianList = props.data.filter((it) => it.bureau === "Experian");
    }

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text">
                            <h2 className="box-title" id="print-credit-history-creditor-contact-info">
                                Creditor Contact Information
                            </h2>
                        </div>
                    </div>
                    <div className="box-description"></div>
                    <div className="box-actions"></div>
                </div>

                <div className="box-content">
                    {transUnionList != null && transUnionList.length > 0 ? <PrintCreditHistoryCreditorContactInfoSingle data={transUnionList} /> : ""}

                    {equifaxList != null && equifaxList.length > 0 ? <PrintCreditHistoryCreditorContactInfoSingle data={equifaxList} /> : ""}

                    {experianList != null && experianList.length > 0 ? <PrintCreditHistoryCreditorContactInfoSingle data={experianList} /> : ""}
                </div>
            </div>
        </React.Fragment>
    );
};

export default PrintCreditHistoryCreditorContactInfo;
